import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { setBluetooth } from "../../commands/mdmCommands";

function bluetoothLabel(value) {
  if (value === true) return "eingeschaltet";
  if (value === false) return "ausgeschaltet";
  return "unbekannt";
}

function BluetoothModal({ visible, device, hideModal, onIssued }) {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    hideModal();
  };

  useEffect(() => {
    setShow(visible);
  }, [visible]);

  function send(enabled) {
    setBluetooth(device.UDID, enabled).then(() => {
      onIssued?.();
      handleClose();
    });
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Bluetooth</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Zuletzt gesetzter Zustand: <strong>{bluetoothLabel(device?.bluetoothEnabled)}</strong>
        </p>
        <p className="form-text mb-0">
          Nur betreute iPhones, iPads und Macs. Der tatsächliche Schalter am Gerät
          kann danach vom Nutzer wieder geändert werden, sofern kein Profil ihn sperrt.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Schließen
        </Button>
        <Button variant="outline-secondary" onClick={() => send(false)}>
          Ausschalten
        </Button>
        <Button variant="success" onClick={() => send(true)}>
          Einschalten
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default BluetoothModal;
